/**
 * Valori di default. Da non utilizzare direttamente, prenderli da
 * `props.theme` di styled-components.
 */
export const uiTheme = {
  contentMaxWidth: 1200,
  layoutHeaderHeight: 64, // altezza totale della header -> influenza gli elementi esterni alla header
  layoutHeaderContentHeight: 64, // altezza interna del contenuto del header
  layoutSiderWidth: 200,
  layoutSiderCollapsedWidth: 60,
  moduleSiderWidth: 300,

  // Underline BreadCrumb
  breadcrumbTextDecoration: 'none',

  // variabile per indicare la posizione del Tag di stato nella pagina di dettaglio della richiesta
  submissionStateTagPositionAfter: false,
  // indica se color del menu delle lingue deve essere bianco
  whiteLanguageMenuColor: false,

  // larghezza colonna per la navigazione delle sezioni in compilazione
  sectionNavigationWidth: 250,
  sectionNavigationWidthMd: 180,

  // Button - per esportare nel tema il corrispettivo impostato nel token (Button.lineWidth)
  tokenButtonLineWidth: 1,

  boxShadowTailwindSm:
    '0 1px 2px 0 rgba(0, 0, 0, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.1);',
  boxShadowTailwindMd:
    '0 4px 6px -1px rgba(100, 116, 139, 0.1), 0 2px 4px -2px rgba(100, 116, 139, 0.1);',

  boxShadowCustomLine:
    '0px 1px 1px 0 rgba(100, 116, 139, 0.08), 0px 1px 2px 0 rgba(100, 116, 139, 0.1);',
  // [Accessibilità] Colore del bordo di evidenziazione del Focus
  focusOutlineColor: '#2384d9',
  focusOutlineNegativeColor: '#c3e3ff',
  // [Accessibilità] Colore titolo della tabella
  tableTitleBackgroundColor: '#48548B',
  // RTE
  // margine inferiore per i tag html display: block (p, ul, ol, ecc.)
  rteHtmlTagMarginBottom: 0, // 0.4,
  rteLinkColor: '#0066cc',
  rteLinkHoverColor: '#0053a6',

  // Widget
  compactWidgetHeight: 72,

  // Padding Base per gli elemento di configurazione degli Elementi
  paddingBaseCalc: 4,

  spaceImageUrl: require('./images/space.png'),

  // colori stato compilazione modulo
  moduleStateErrorColor: '#cb1d15',
  moduleStateValidColor: '#757575',
  moduleStateSignColor: '#531dab',
  moduleStateCompletedColor: '#008554',
  // colori dei banner di riepilogo compilazione modulo
  moduleDelegateColor: '#722ed1',
  // Colori distintivi degli eventi di sistema nella cronologia del
  // procedimento: combinazione testo/fondo del Tag "purple" di Ant Design
  // (il fondo riempie anche il bordo del pannello)
  systemEventColor: '#531dab',
  systemEventFillColor: '#f9f0ff',
  // A11Y accessibilità
  colorTextPlaceholderDisabled: '#606060',

  // dossier card
  colorBgDossierCard: '#d9edfc', //'#d9eef7',

  // FilterBar - colori del chip di filtro (sfondo + bordo).
  // Default qui nel tema base; sovrascrivibili per cliente nei rispettivi
  // `theme.tsx` (es. theme-rer) come qualsiasi altro token.
  colorBgFilterBarChip: '#f0f7ff',
  colorBorderFilterBarChip: '#d1e1f2',

  // Indica se visualizzare il numero di protocollo nell'elenco delle richieste
  // o il numero istanza
  showProtocolNumberAsSubmissionNumberColumn: false,

  // Indica che la Header dall'applicativo e scura (BO e ADMIN)
  darkAdminHeaderFlag: false,

  // Indica che la Header del Frontoffice è scura
  darkFrontofficeHeaderFlag: true,

  searchButtonOnTableFlag: false, // indica se visualizzare il pulsante di ricerca sopra la tabella

  // indica se eliminare l'altezza fissa della header
  // utilizzato per eliminare il margine superiore impostato nel content della pagina
  // &.has-top-bar.fixed-header
  overrideLayoutHeaderHeightFlag: false,

  // indica se il layout di header e footer del Frontoffice
  // prevede il contenuto a tutta pagina o con un massimo di larghezza (boxed)
  // gestito parzialmente in componenti specifici
  boxedFrontofficeHeaderFooterLayoutFlag: false,

  // Indica se forzare la visualizzazione delle tabelle a tutta larghezza della pagina
  // sovrascive la proprietà `boxed` del PageLayoutBase
  // se nel PageLayoutBase è impostato `isTablePage` a true
  tablePageFullWidthFlag: false,

  // Indica che la colonna con le azioni è fissa solo se è presenti tag semantici tra le colonne.
  // In sostanza la tabella _scrolla_ solamente se ci sono tag semantici (che hanno il flag `enableScroll`)
  tableScrollRequiresColumnFlag: false,

  // Indica se visualizzare la colonna con la fase nella lista delle richieste personali
  showPhaseSubmissionColumn: false,
  // Indica se visualizzare il filtro per Area
  showAreaInquiryFilter: false,

  // Flags per la visualizzazione del drawer PDF
  viewPdfLabel: 'Apri',
  enablePdfDrawer: false,

  openModulePdfInNewWindow: false,

  // Indica se è necessaria la PEC per l'ufficio
  isOfficePecRequired: true,

  // Indica se mostrare l'icona alternativa per il riepilogo
  showAlternateSummaryIcon: false,

  // Se impotata a true, reindirizza al modulo principale all'avvio di una domanda
  redirectToFirstModule: false,

  // Indica se mostrare il badge di validazione della sezione
  showSummarySectionBadge: true,

  // Flag per nascondere la tab dei documenti nella pagina del procedimento
  hideProcedureDocumentsTab: false,

  // Flag per visualizzare anche il codice nella selezione dell'ufficio
  showOfficeCodeDropdown: false,

  /**
   * Utilizzato per nascondere il footer dato che
   * se il loading capita sotto risulterebbe invisibile
   */
  forceRemoveFooterOnLoadingPage: false,
  /**
   * Flag per mostrare header e footer anche nella pagina di login
   */
  showHeaderFooterOnLoginPage: false,
  /**
   * Mostra, in integrazione della richiesta, i campi in sola lettura come
   * disabilitati (disabled) invece che in sola lettura (readonly).
   */
  showIntegrationReadonlyWidgetsAsDisabled: false,
};

/**
 * Espone il tema dell'interfaccia utente, in modo che sia
 * possibile sovrascriverlo.
 */
export type IUiTheme = typeof uiTheme;
